import { get, omit } from 'lodash-es';
import { CrmPagination } from 'common-module/table';
import { CrmSelectOption } from 'common-module/select';
import { getMediaResourceURL } from '@app/utils/media.utils';

import { Product } from '../core/model/product';

export const getCommercialYear = (id: string, years: Product[]) =>
  years.find((cy) => cy.meta.identifier === id);

export const getBaseSearchParams = (
  filters: any,
  pagination: CrmPagination,
  extraParams?: any,
  selectProperties: string[] = [],
) => {
  const reqParams = {
    ...buildCommercialYearParams(filters?.filter?.commercialYear),
    ...buildRdpStatusFilterParams(filters?.filter?.rdpStatus),
    ...buildPlCardStatusFilterParams(filters?.filter?.plcardStatus),
  };

  return {
    type: 'product',
    ...filters?.sort,
    ...omit(pagination, 'total'),
    ...reqParams,
    ...selectProperties.reduce(
      (p, c, i) => ({ ...p, [`$select[${i}]`]: c }),
      {},
    ),
    ...extraParams,
  };
};

export const getProductThumbnail = (product: Product) => {
  const images = product?.media ?? [];
  if (!images.length) {
    return '/assets/images/img-placeholder-padded.svg';
  }
  if (!images[0]?._id) {
    return '/assets/images/img-placeholder-padded.svg';
  }
  return getMediaResourceURL(images[0]._id);
};

const buildCommercialYearParams = (commercialYear?: string) => {
  return commercialYear ? { 'meta.timing.commercialYear': commercialYear } : {};
};

const buildRdpStatusFilterParams = (rdpStatus: string[]) =>
  buildPropInParams('meta.logistics.combinedStatus', rdpStatus);

const buildPlCardStatusFilterParams = (plcardStatus: string[]) =>
  buildPropInParams('meta.plcardStatus', plcardStatus);

const buildPropInParams = (
  key: string,
  values: string[],
): Record<string, any> => {
  if (Array.isArray(values) && values?.length > 1) {
    return (values as string[]).reduce(
      (a, s, i) => ({
        ...a,
        [`${key}[$in][${i}]`]: s,
      }),
      {},
    );
  }

  return values?.length ? { [key]: values[0] } : {};
};

export const productToSelectOptionByName =
  (property: string): ((product: Product) => CrmSelectOption) =>
  (product: Product) => ({
    label: product.name,
    value: get(product, property),
  });
